export const ADD_TAB = 'ADD_TAB';
export const REMOVE_TAB = 'REMOVE_TAB';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const ADD_MEDICINE_TO_TAB = 'ADD_MEDICINE_TO_TAB';
export const ADD_PENDING_MEDICINE = 'ADD_PENDING_MEDICINE';
export const CONSUME_PENDING_MEDICINE = 'CONSUME_PENDING_MEDICINE';
export const INIT_TABS_FROM_STORAGE = 'INIT_TABS_FROM_STORAGE';
export const LOAD_TABS_FROM_STORAGE = 'LOAD_TABS_FROM_STORAGE';
export const DELETE_TAB = 'DELETE_TAB';
export const CLEAR_TABS = 'CLEAR_TABS';
export const UPDATE_MEDICINE_IN_TAB = 'UPDATE_MEDICINE_IN_TAB';
export const REMOVE_MEDICINE_FROM_TAB = 'REMOVE_MEDICINE_FROM_TAB';
